import React, { useCallback, useEffect } from "react";
import useTimer from "../common/useTimer";
import { Col, Row } from "reactstrap";

/**
 * TimerComponent is a React component that displays a countdown timer.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {number} props.timerSeconds - The number of seconds for the timer.
 * @param {string} props.timeoutText - The text to display when the timer reaches 0.
 * @param {string} props.remainingText - The text to display when the timer is still running.
 * @param {function} props.t - The translation function.
 * @returns {JSX.Element} The TimerComponent JSX element.
 */
function TimerComponent({
  timerSeconds,
  timeoutText,
  remainingText,
  t,
}) {
  const { start, timeLeft } = useTimer();

  if (typeof timerSeconds === undefined) {
    throw new Error("timerSeconds is required");
  }

  if (typeof t === undefined) {
    throw new Error("t is required");
  }

  if (typeof timeoutText === undefined || typeof remainingText === undefined) {
    throw new Error("timeoutText or remainingText is required");
  }

  const renderRemainingTime = useCallback(() => {
    if (timeLeft === 0) {
      return t(timeoutText);
    } else {
      const minutes = Math.floor(timeLeft / 60);
      const seconds = timeLeft % 60;
      return t(remainingText, {
        time: `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`,
      });
    }
  }, [timeLeft]);

  useEffect(() => {
    start(timerSeconds);
  }, [timerSeconds]);

  return (
    <Row>
      <Col>
        <h5
          className="text-center mt-2"
          style={{
            color: "#f00",
          }}
        >
          {renderRemainingTime()}
        </h5>
      </Col>
    </Row>
  );
}

export default TimerComponent;
